import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalDialog, Modal } from "react-bootstrap";
// import TemplateEditor from "./grape";
import Button from "react-bootstrap-button-loader";
import Iframe from "react-iframe";
import { GRAPESJE_EDITOR } from "Constants";
// import "grapesjs/dist/css/grapes.min.css";

class GrapesmodalContent extends Component {
  constructor(props) {
    super(props);
    var greapeseditor = GRAPESJE_EDITOR;
    this.state = {
      greapeseditor,
    };
  }

  render() {
    let { session, pageid, section, headerid  } = this.props;


    return (
      // <ModalDialog dialogClassName="my-modal ">
      <Modal
        show={this.props.isOpen}
        onHide={this.props.onClose}
        className="modal-container grapes-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Woohoo, you're reading this text in a modal! */}
          {/* <TemplateEditor /> */}
          {/* <Iframe url="https://grapesjs.com/demo.html" */}
   
          <Iframe
            // url={`${this.state.greapeseditor}?pageid=${pageid}&apikey=${session.apiKey}&session_token=${session.sessionToken}&section=${section}`}
            url={`${this.state.greapeseditor}?pageid=${pageid}&apikey=${session.apiKey}&session_token=${session.sessionToken}&section=${section}&headerid=${headerid}`}
            width="100%"
            height="100%"
            id="myId"
            className="myClassname"
            display="initial"
            position="relative"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      // </ModalDialog>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps)(GrapesmodalContent);
